import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {UserContextProvider} from "context";
import {connectSentry} from "sentry";
import {initMixpanel} from "mixpanel";
import "assets/styles/index.scss";

connectSentry();
initMixpanel();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
//  <React.StrictMode>
    <BrowserRouter>
      <UserContextProvider>
        <App />
      </UserContextProvider>
    </BrowserRouter>
//  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
